import { IPaginationParams, IPaginationResponse } from 'interfaces/pagination';
import * as rxjs from 'rxjs';

import apiService, { ApiService } from './api';
import { statusesDashboard } from 'interfaces/dashboard';

interface IReportArgs {
  params: IPaginationParams;
  ventureId: number;
  categoryId?: number;
  entityId?: number;
  reportType: string;
  status?: statusesDashboard;
  onlyLatestFiles?: boolean;
  snapshotId?: string;
}

interface IExportXLSArgs {
  ventureId: number;
  reportType?: string;
  status?: statusesDashboard;
  categoryId?: number;
  entityId?: number;
  snapshotId?: string;
}

export class ReportService {
  constructor(private apiService: ApiService) {}

  public report(args: IReportArgs): rxjs.Observable<IPaginationResponse<any>> {
    const {
      params,
      ventureId,
      reportType,
      status,
      onlyLatestFiles,
      snapshotId,
      categoryId,
      entityId,
    } = args;

    let url = `/file/report/${reportType}/venture/${ventureId}`;
    if (categoryId) {
      url += `/category/${categoryId}`;
      if (entityId) {
        url += `/entity/${entityId}`;
      }
    }

    const _params: any = { ...params, reportType, onlyLatestFiles };
    if (status) {
      _params.status = [status];
    }
    if (snapshotId) {
      _params.snapshotId = snapshotId;
    }

    return this.apiService.get(url, _params);
  }

  public exportReportAccessXLS(): rxjs.Observable<any> {
    return this.apiService.post('/user/report/xls', {});
  }

  public exportCSV(ventureId: number): rxjs.Observable<any> {
    return this.apiService.post(`/file/report/csv/venture/${ventureId}`, {});
  }

  public exportXLS(args: IExportXLSArgs): rxjs.Observable<any> {
    const { reportType, ventureId, categoryId, entityId, status, snapshotId } =
      args;
    const body = {
      status,
      snapshotId,
    };
    let url = `/file/report/${reportType}/xls/venture/${ventureId}`;
    if (categoryId) {
      url += `/file/report/${reportType}/xls/venture/${ventureId}/category/${categoryId}`;
      if (entityId) {
        url += `/file/report/${reportType}/xls/venture/${ventureId}/category/${categoryId}/entity/${entityId}`;
      }
    }
    return this.apiService.post(url, body);
  }
}

const reportService = new ReportService(apiService);
export default reportService;
